import React, { useEffect, useState } from "react";
import { Typography, Grid, makeStyles, Box } from "@material-ui/core";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import CommonModal from "../../common/modals/CommonModal";
import StyledFormTextField from "../../common/textFields/StyledFormTextField";
import StyledDescriptionTextField from "../../common/textFields/StyledDescriptionTextField";

import styles from "./EventModa.styles";
import EVENTS_HELPER_TEXTS from "../../../constants/eventsHelperTexts";
import { shop } from "../../../utils/newApi";
import {
  SERVER_ERROR_MESSAGES,
  MODAL_TYPE,
  COMMON_MODAL_TEXTS,
} from "../../../constants/dictionary";
import { id } from "date-fns/locale";

const useStyles = makeStyles(styles);

const EditEventWindow = ({
  events,
  setEvents,
  isOpen,
  close,
  data,
  handleError,
}) => {
  const classes = useStyles();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const currentDate = new Date();
  const [dateSince, setDateSince] = useState(currentDate);
  const [dateTo, setDateTo] = useState(currentDate);
  const [hourSince, setHourSince] = useState(currentDate);
  const [hourTo, setHourTo] = useState(currentDate);
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
    setName(data.title);
    setDescription(data.description);
    setDateSince(new Date(data.startDate));
    setDateTo(new Date(data.endDate));
    setHourTo(new Date(data.endDate));
    setHourSince(new Date(data.startDate));
  }, [data, isOpen]);

  const submit = (e) => {
    const combinedDateTo = `${format(dateTo, "yyyy/MM/dd")} ${format(
      hourTo,
      "H:mm:ss"
    )}`;
    const date = Date.parse(combinedDateTo);
    const finalDateTo = new Date(date);
    const combinedDateSince = `${format(dateSince, "yyyy/MM/dd")} ${format(
      hourSince,
      "H:mm:ss"
    )}`;
    const date2 = Date.parse(combinedDateSince);
    const finalDateSince = new Date(date2);

    const payload = {
      description: description,
      endDate: finalDateTo.toISOString(),
      startDate: finalDateSince.toISOString(),
      title: name,
    };

    if (name === "" || description === "") {
      setError(true);
      return;
    }

    if (Date.parse(finalDateSince) < finalDateTo) {
      setError(false);
      shop.events
        .edit(data.id, payload)
        .then((res) => {
          if (events) {
            let eventsCopy = [...events];
            eventsCopy = eventsCopy.map((item) => {
              if (item.id === data.id) {
                return {
                  id: item.id,
                  ...payload,
                };
              } else {
                return item;
              }
            });

            setEvents(eventsCopy);
            close();
          } else {
            window.location.reload();
          }
        })
        .catch((err) => {
          handleError(SERVER_ERROR_MESSAGES.COULD_NOT_EDIT_EVENT);
        });
    } else {
      setError(true);
    }
  };

  return (
    <CommonModal
      open={isOpen}
      toggleOpen={close}
      handleConfirmation={submit}
      title={COMMON_MODAL_TEXTS.EDIT_EVENT_TITLE}
      type={MODAL_TYPE.EDIT}
    >
      <Grid item xs={12}>
        <Box className={classes.box}>
          <StyledFormTextField
            InputLabelProps={{ classes: { root: classes.label } }}
            fullWidth={true}
            label="Wpisz tytuł wydarzenia"
            variant="outlined"
            required
            shrink="true"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Box>
      </Grid>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container direction="row" justify="center">
          <Grid item xs={12} md={6}>
            <Box className={classes.box2}>
              <KeyboardDatePicker
                disableToolbar
                fullWidth={true}
                variant="outline"
                format="MM/dd/yyyy"
                margin="normal"
                label="Od"
                value={dateSince}
                onChange={(date) => setDateSince(date)}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box className={classes.box2}>
              <KeyboardDatePicker
                disableToolbar
                fullWidth={true}
                variant="outline"
                label="Do"
                format="MM/dd/yyyy"
                margin="normal"
                value={dateTo}
                onChange={(date) => setDateTo(date)}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </Box>
          </Grid>
        </Grid>
        <Grid container direction="row" justify="center">
          <Grid item xs={12} md={6}>
            <Box className={classes.box2}>
              <KeyboardTimePicker
                fullWidth={true}
                ampm={false}
                variant="outline"
                label="Godzina od"
                margin="normal"
                value={hourSince}
                onChange={(date) => setHourSince(date)}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box className={classes.box2}>
              <KeyboardTimePicker
                ampm={false}
                fullWidth={true}
                variant="outline"
                label="Godzina do"
                margin="normal"
                value={hourTo}
                onChange={(date) => setHourTo(date)}
              />
            </Box>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
      {error && (
        <Grid item xs={12} align="center">
          <Box className={classes.box}>
            <Typography className={classes.error}>
              {name === "" || description === ""
                ? "Nie wypełniono obowiązkowych pól"
                : EVENTS_HELPER_TEXTS.dateError}
            </Typography>
          </Box>
        </Grid>
      )}
      <Grid item xs={12}>
        <Box className={classes.box}>
          <StyledDescriptionTextField
            InputLabelProps={{ classes: { root: classes.label } }}
            fullWidth={true}
            label="Opis wydarzenia"
            variant="outlined"
            required
            rows={4}
            shrink="true"
            value={description}
            multiline={true}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Box>
      </Grid>
    </CommonModal>
  );
};

export default EditEventWindow;
